import React, { useMemo, useState } from 'react';
import WorkflowUtilityPanel from './WorkflowUtilityPanel';
import { searchWorkflowSteps } from '../../utils/workflowBuilderUtils';

const WorkflowSearchPanel = ({ steps = [], onClose, onSelectResult }) => {
  const [query, setQuery] = useState('');

  const results = useMemo(() => searchWorkflowSteps(steps, query), [steps, query]);

  return (
    <WorkflowUtilityPanel title="Search workflow" onClose={onClose} testId="workflow-search-panel">
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search actions, labels, notes, emails, SMS, backend keys..."
        className="mb-4 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
        data-testid="workflow-search-input"
      />

      {query.trim() && results.length === 0 ? (
        <p className="text-sm text-slate-500">No matching actions found.</p>
      ) : (
        <div className="space-y-2">
          {results.map((result) => (
            <button
              key={result.stepId}
              type="button"
              onClick={() => onSelectResult(result.stepId)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-left hover:border-sky-300 hover:bg-sky-50/40"
              data-testid={`search-result-${result.stepId}`}
            >
              <p className="text-sm font-medium text-slate-900">{result.label}</p>
              <p className="text-xs text-slate-500">
                {result.type} · {result.matchText}
              </p>
            </button>
          ))}
        </div>
      )}
    </WorkflowUtilityPanel>
  );
};

export default WorkflowSearchPanel;
